"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateWalletOptions = void 0;
class CreateWalletOptions {
    userId;
    mangopayId;
    currency;
}
exports.CreateWalletOptions = CreateWalletOptions;
//# sourceMappingURL=CreateWalletOptions.js.map